import {THEME_COLORS} from 'common/theme/_colors'
import {THEME_SEMANTICS} from 'common/theme/_semantics'
import styled from 'styled-components'

export const StyledFacebookMessageConfirmOrder_Tbody = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  background: #fff;
  border-top: 1px solid #e2eaf8;

  transition: background 0.25s;

  &:hover {
    background: #f3f6fc;
  }

  .facebook-message-confirm-order-tbody {
    &__td {
      height: 100%;
      min-height: 70px;
      padding: 12px;

      display: flex;
      align-items: center;

      font-size: 14px;
      line-height: 20px;

      &:nth-child(1) {
       flex: 1;
        padding-left: 24px;
      }
      &:nth-child(2) {
        width: 531px;
        justify-content: center;
      }
      &:nth-child(3) {
        width: 200px;
        justify-content: center;
      }
&:nth-child(4) {
        cursor: pointer;
        width: 100px;
        justify-content: center;
        &:hover{
          svg{
            path{
              stroke: #1E9A98;
            }
          }
        }
      }
      .--ellipsis {
        display: flex;
        align-items: center;
        gap: 12px;
      }
    }
    &__image{
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }
    &__menu {
      width: 164px;
    }

    &__menu-item {
      height: 36px;
      padding: 0 4px;

      display: flex;
      align-items: center;

      font-size: 14px;
      line-height: 20px;

      transition: all 0.25s;

      cursor: pointer;

      &[data-type='danger'] {
        &:hover {
          color: ${THEME_SEMANTICS.failed}!important;

          svg {
            path[fill] {
              fill: ${THEME_SEMANTICS.failed};
            }

            path[stroke] {
              stroke: ${THEME_SEMANTICS.failed};
            }
          }
        }
      }

      &:hover {
        color: ${THEME_COLORS.primary_300}!important;

        svg {
          path[fill] {
            fill: ${THEME_COLORS.primary_300};
          }

          path[stroke] {
            stroke: ${THEME_COLORS.primary_300};
          }
        }
      }
    }

    &__menu-icon {
      margin-right: 10px;

      svg {
        transform: translateY(2px);
      }
    }
  }

  .common-ellipsis {
    max-width: 100%;

    overflow: hidden;
    white-space: nowrap;

    text-overflow: ellipsis;

    cursor: pointer;

    &.--multiple {
      display: -webkit-box;

      white-space: unset;

      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .tooltipV2 {
    display: -webkit-box;
    height: 100%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
   .tooltipV2_message {
    display: -webkit-box;
    height: 100%;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
